<template>
<!-- Contenedor Principal-->
<b-container fluid>
  <div class="white">
    <h1 class="primer-fila text-center">Consulta de Licencias</h1>
    <h5 class="primer-fila" >{{ (this.getEstablecimiento ? this.getEstablecimiento.DisplayNivelAsignado : '') }}</h5>
    <hr>
    <b-row>
      <b-col md="12">
          <b-row>
            <b-col md="4">
              <b-form-group label="Buscar:">
                  <!-- <b-form-input v-model="SearchTerm" placeholder="" /> -->
                <b-input-group>
                  <b-form-input v-model="inputSearch" @change="licenciasProviderLocal(1)" placeholder="" />
                  <b-input-group-append>
                    <b-button text="Button" variant="primary"><b-icon icon="search"></b-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <tipo-licencia-select></tipo-licencia-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Desde:">
                <b-form-datepicker v-model="inputFechaDesde" @input="licenciasProviderLocal(1)" class="mb-2"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col v-if="this.getEstablecimiento.NivelEnseñanza_Id === null" md="8">
              <b-form-group label="Establecimiento:">
                <b-input-group size="sm" prepend="Establecimiento" class="mb-2">
                  <b-form-select size="sm"
                    :disabled="disabled"
                    v-model="FiltroEstablecimiento.selected"
                    :options="FiltroEstablecimiento.opciones"
                    @change="licenciasProviderLocal(1)">
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group>
            <b-btn
              :disabled="!SearchTerm && !FechaDesde && !TipoLicencia && !DetalleDiasLicencia"
              @click="limpiarFiltro()"
              variant="primary">
              Limpiar filtros
            </b-btn>
            <b-btn title="Exportar a pdf" variant="primary"  @click="exportarPdf()" >
              Exportar a PDF
              <b-icon icon="file-text"></b-icon>
            </b-btn>
            <download-excel
            class="btn btn-default"
            :fetch="dataForExcel"
            worksheet="Licencias"
            name="licencias.xls">
              Exportar a Excel
              <b-icon icon="file-excel"></b-icon>
            </download-excel>
        </b-form-group>
      </b-col>
    </b-row>
    <hr>
  </div>
  <div class="white">
    <b-row>
      <b-col md="12">
        <tabla-licencias v-on:tabla-remover-licencia="eliminarLicencia($event)"></tabla-licencias>
      </b-col>
    </b-row>
  </div>
</b-container>
</template>

<script>
import moment from 'moment'
import {mapGetters,mapActions} from 'vuex'
import TipoLicenciaSelect from '../../common/TipoLicenciaSelect.vue'
import TablaLicencias from '../../common/TablaLicencias.vue'

import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapFormLicenciaFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});
const { mapFields: mapFiltroLicenciaFields } = createHelpers({
  getterType: "FiltroLicenciaModule/getFiltroLicenciaField",
  mutationType: "FiltroLicenciaModule/updateFiltroLicenciaField"
});
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  // OR register locally
    components: { TipoLicenciaSelect, TablaLicencias },
  name: 'ConsultaLicencia',
  computed:{
    ...mapGetters(['getUserInfo', 'getUserName','getEstablecimiento','isInRoleAdmin', 'isInRoleCoordinador']),
    ...mapFormLicenciaFields(['TipoLicencia', 'TipoLicencia_Id', 'DetalleDiasLicencia']),
    ...mapFiltroLicenciaFields(['FiltroEstablecimiento', 'FechaDesde', 'FechaHasta','SearchTerm']),
    ...mapFormBuscarPersonalFields(['Personal_Id']),
  },
  watch: {

  },
  data() {
    return {
      disabled: false,
      inputSearch: null,
      inputFechaDesde: null,
      listacolegios: [],
    }
  },
  methods: {
    ...mapActions("NivelModule", ["getLista", "getEstablecimientos"]),
    licenciasProviderLocal(resetPagination) {
      console.log('resetPagination', resetPagination, this.inputSearch, this.inputFechaDesde);
      this.SearchTerm = this.inputSearch;
      this.FechaDesde = this.inputFechaDesde;
    },
    eliminarLicencia(item){
      console.log('eliminarLicencia', item);
    },
    limpiarFiltro(){
      var mesAnterior = moment().subtract(12, 'months').format("YYYY-MM-DD");
      this.SearchTerm = null;
      this.FechaDesde = mesAnterior;
      this.TipoLicencia = null;
      this.DetalleDiasLicencia = null;
    },
    getSelectEstablecimientos(){
      console.log('getSelectEstablecimientos licencias');
      this.getEstablecimientos()
        .then((r) => {
          console.log('getSelectEstablecimientos then', r);
          if(this.getEstablecimiento.NivelEnseñanza_Id === null){
            if(this.getEstablecimiento.UnidadEducativa_Id === null){
              this.listacolegios.push({ value: -1, text: '-SAED-' });
            }
            this.listacolegios.push({ value: 0, text: '--Todos--' });
            r.data.rows.forEach((element) => {
              this.listacolegios.push({ value: element.Id, text: element.DisplayUnidadEducativaNivelSinCuise });
            });
            this.FiltroEstablecimiento.opciones = this.listacolegios.sort((a, b) => a.text > b.text ? 1 : -1);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async dataForExcel(){
      let doc = new jsPDF('l', 'mm', [297, 210]);
      doc.text(`Licencias ${this.TipoLicencia ? this.TipoLicencia.Articulo : ''}`, 14, 16);

      let elem = document.getElementById("tablaLicencias");
      let res = doc.autoTableHtmlToJson(elem);
      let excelData = [];
      res.data.forEach(e => {
        excelData.push({
          Nombre: e[0].textContent,
          Cargo:  e[1].textContent,
          Articulo: e[2].textContent,
          Solicitud: e[3].textContent,
          Desde: e[4].textContent,
          Hasta: e[5].textContent,
          CantidadDias: e[6].textContent
        });
      });
      return excelData;
    },
    exportarPdf(){
      var doc = new jsPDF('l', 'mm', [297, 210]);
      doc.text(`Licencias ${this.TipoLicencia ? this.TipoLicencia.Articulo : ''}`, 14, 16);

      var elem = document.getElementById("tablaLicencias");
      var res = doc.autoTableHtmlToJson(elem);
      //Ignorar columna 0 y 6 de la tabla
      res.columns.splice(7, 1);
      res.columns.splice(1, 1);
      res.data.forEach(e => {
        e.splice(7, 1);
        e.splice(1, 1);
      });
      doc.autoTable(res.columns, res.data, {startY: 20});
      doc.save(`Licencias.pdf`);
    },
  },
  mounted() {
    var mesAnterior = moment().subtract(12, 'months').format("YYYY-MM-DD");
    var hoy = moment().format("YYYY-MM-DD");
    this.inputFechaDesde = mesAnterior;
    this.Personal_Id = null;
    this.TipoLicencia_Id = -1;
  },
  created() {
    console.log('this.FiltroEstablecimiento',this.FiltroEstablecimiento);
    console.log('this.getEstablecimiento',this.getEstablecimiento);
    this.getSelectEstablecimientos();
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/licencias/ConsultaLicencia.vue